import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BlockListSpotsModule } from '@features/spots/umbraco-block-list-spot/block-list-spots.module';
import { UmbracoBlockListComponent } from '@features/umbraco-block-list/umbraco-block-list.component';

@NgModule({
    imports: [CommonModule, BlockListSpotsModule, UmbracoBlockListComponent],
    exports: [UmbracoBlockListComponent]
})
export class UmbracoBlockListModule {}
